export default "__VITE_ASSET__5a005d9f__"